module.exports = __webpack_public_path__ + "static/WEDDING E&M-158-aea150658e2009dc878eed860c4e5262.jpg";